import * as React from 'react';

function SvgDollar(props) {
  return (
    <svg viewBox="0 0 10 14" fill="none" {...props}>
      <path
        d="M8.305 9.46c0 .756-.276 1.378-.828 1.868-.553.49-1.35.792-2.391.906v1.696h-1.04V12.28c-1.29-.02-2.35-.219-3.179-.594V10.04c.448.219.972.404 1.57.555a7.22 7.22 0 001.61.226V7.898l-.656-.242c-.855-.328-1.48-.718-1.875-1.172C1.125 6.026.93 5.461.93 4.79c0-.719.278-1.31.836-1.773.562-.464 1.323-.745 2.28-.844V.859h1.04v1.29c1.057.036 2.06.25 3.008.64l-.57 1.43a8.378 8.378 0 00-2.438-.578v2.843l.594.227c.99.38 1.674.781 2.054 1.203.38.422.57.938.57 1.547zm-1.844.118a.955.955 0 00-.32-.742c-.209-.198-.56-.388-1.055-.57v2.492c.917-.14 1.375-.534 1.375-1.18zM2.766 4.773c0 .297.09.545.273.743.188.198.523.393 1.008.586v-2.43c-.417.062-.734.19-.953.383a.92.92 0 00-.328.718z"
        fill={props.color}
      />
    </svg>
  );
}

export default SvgDollar;
